export default {
    acquiring_device: "To‘lov qabul qilish qurilmasi",
    add_expense: "Xarajatlarni qo'shish",
    add_income: "Daromad qo'shing",
    advance_noun: "Avans",
    all_pay_methods: "Barcha to'lov usullari",
    bank_terminal: "Bank terminali",
    cash_operation: "Naqd pul muomalasi",
    cashdesk: "Kassa",
    cashier: "Kassir",
    cashier_inn: "Kassir INN",
    cashier_name: "Kassir nomi",
    cashless_payment: "Naqd pulsiz to'lov",
    cashless_payments: "Naqd pulsiz to'lovlar",
    cheque: "Chek",
    cheque_generation_in_process_status_might_change_later: "Chekni yaratish jarayoni davom etmoqda. Holatning o'zgarishi biroz vaqt olishi mumkin.",
    cheques: "Cheklar",
    close_shift: "Smenani yopish",
    closing_balance: "Kun oxiridagi balans",
    create_cheque: "Fiskal chek yaratish",
    dashboard: "Dosh paneli",
    data_is_invalid: "Ma’lumotlar noto‘g‘ri",
    data_is_valid: "Ma’lumotlar to‘g‘ri",
    deposit_to_cashdesk: "Kassaga to‘lov qilish",
    enter_amount: "Miqdorni kiriting",
    enter_the_cheque_number: "Chek raqamini kiriting",
    error_printing_cheque: "Chekni chop etishda xatolik",
    fiscal_cheque_copy_print: "Fiskal tekshiruv nusxasi Chop etish",
    fiscal_cheque_print: "Fiskal tekshiruv bosqichi",
    fiscal_device: "Fiskal qurilma",
    fiscal_registrar: "Fiskal ro'yxatga oluvchi",
    fiscal_registrar_management: "Fiscal rectisterni boshqarish",
    fixed: "Doimiy",
    injection: "To'ldirish",
    issue_an_advance: "Oldinga chiqing",
    kkm_url: "Savdo uskunalari serverining HTTP manzili. Kassa serveri mahalliy ravishda ulanmagan bo'lsa, to'ldiring.",
    market_as_fiscal_cheque_manually: "Fiskal chek sifatida qo'lda belgilash",
    name_of_service_in_cheque: "Chiptadagi xizmat nomi",
    not_subject_to_vat: "QQSga soliq qo‘yilmaydi",
    only_for_payment_through_terminal: "Faqat terminal orqali to‘lov uchun",
    open_shift: "Smenani ochish",
    opened_at: "Ochilish sanasi",
    opening_balance: "Kunning boshida muvozanat",
    partial_prepayment: "Qisman oldindan to‘lov",
    print_totals: "Jami summalarni chop etish",
    process_advances_as: "Oldindan to‘lovlarni quyidagilar sifatida qayta ishlash",
    sale_of_goods: "Tovarlarni sotish",
    sales: "Sotuvlar",
    send_services_in_cheque: "Xizmatlarni chiptada yuborish",
    shift: "Smena",
    shift_number: "Smena raqami",
    shifts: "Smenalar",
    system_to_use: "Foydalaniladigan tizim",
    terminal: "Terminal",
    totals: "Jami",
    vat_rate: "QQS stavkasi",
    waiting_for_payment_in_terminal: "Terminalda to‘lovni kutish",
    who_accepts_payment: "To‘lovni kim qabul qiladi",
    withdraw_from_cashdesk: "Kassadan yechish",
    withdrawal: "Olib tashlash",
    withdrawal_replenishment_from_the_cash_register: "Kassani kassadan olish",
    withdrawal_replenishment_of_cash: "Naqd pulni olish / to'ldirish",
    xreport: "X-hisobot",
    xreports: "X-hisobotlar"
}
